import { gql, useQuery } from '@apollo/client';

import { GetPoolsList } from './__generated__/GetPoolsList';

export const GET_POOLS_LIST = gql`
  query GetPoolsList {
    user {
      id
      company {
        id
        pools {
          id
          last_updated_date
          name
          asset_class
          created_date
          loan_count
          state
          t_current_balance_cents
          wa_coupon_bps
          wa_loan_age_months
          wa_borrower_credit_score
          wa_remaining_loan_terms_months
          wa_ltv_bps
          wa_dti_bps
          has_cra
          is_public
        }
      }
    }
  }
`;

export const useGetPoolsList = () => {
  return useQuery<GetPoolsList>(GET_POOLS_LIST, {
    fetchPolicy: 'cache-and-network',
    pollInterval: 5000,
  });
};
